<template>
  <div class="gov-info-page">
    <div class="gov-container">
      <!-- 面包屑导航 -->
      <nav class="breadcrumb-nav">
        <router-link to="/">首页</router-link>
        <span class="separator">/</span>
        <router-link to="/product">产品中心</router-link>
        <span class="separator">/</span>
        <span class="current">政府公示数据采集审计平台</span>
      </nav>
    </div>

    <!-- 英雄区（产品Banner） -->
    <section class="gov-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <h1>政府公示数据采集审计平台<br><span style="color: var(--gov-accent-blue);">爬虫审计 · 外部数据融合 · 智能线索挖掘</span></h1>
        <p class="subhead">基于网络爬虫技术自动采集工商、四库一平台等政府权威公示数据，融合内部ERP、人资、招投标系统，实现违规经商、围标串标、挂证等审计场景智能分析。</p>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal">预约演示 <i class="fa-regular fa-calendar-check" style="margin-left: 8px;"></i></a>
          <a href="#" class="btn btn-outline" @click.prevent="downloadBrochure">下载产品手册 <i class="fa-regular fa-file-pdf" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键词云（SEO强化） -->
      <div class="keyword-cloud">
        <h2 class="keyword-tag highlight">网络爬虫系统</h2>
        <h2 class="keyword-tag">政府公示数据采集</h2>
        <h2 class="keyword-tag">审计大数据</h2>
        <h2 class="keyword-tag">违规经商排查</h2>
        <h2 class="keyword-tag">围标串标审计</h2>
        <h2 class="keyword-tag">供应商风险识别</h2>
        <h2 class="keyword-tag">外部数据审计</h2>
        <h2 class="keyword-tag">招投标异常分析</h2>
        <h2 class="keyword-tag">企业关联关系</h2>
        <h2 class="keyword-tag">员工挂证审计</h2>
      </div>
    </section>

    <!-- 背景与痛点 -->
    <section class="gov-container">
      <h2><i class="fa-regular fa-triangle-exclamation"></i> 行业背景与核心痛点</h2>
      <div class="card-grid-3">
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-cloud"></i></div>
          <h3>外部数据获取难</h3>
          <p>数据分散在多个政府平台，人工查询效率低，无法持续更新，字段无法结构化。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-code-branch"></i></div>
          <h3>关联关系复杂</h3>
          <p>隐性利益输送、挂证、违规经商、围标串标等问题隐蔽，传统手段难以识别。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-link"></i></div>
          <h3>内外部数据割裂</h3>
          <p>ERP、人资、招投标数据与工商数据未打通，无法进行IP、MAC、法人关联分析。</p>
        </div>
      </div>
      <p style="margin-top: 20px; font-size: 1.1rem;">在"科技强审""审计全覆盖"政策推动下，构建基于爬虫技术的外部数据采集与内外部融合分析平台，已成为审计数字化转型的关键支撑。</p>
    </section>

    <!-- 解决方案概览 -->
    <section class="gov-container">
      <div class="arch-card" style="background: var(--gov-primary-dark); color: white;">
        <h2 style="color: white; margin-bottom: 20px;">整体解决方案</h2>
        <p style="font-size: 1.2rem; max-width: 900px; margin: 0 auto;">通过"政府权威公示数据采集 + 内部系统数据融合 + 十大数据中间表建模 + 重点审计场景智能分析 + 可视化操作平台"，打造外部数据驱动的审计大数据平台。</p>
      </div>
    </section>

    <!-- 核心功能模块（五大模块） -->
    <section class="gov-container">
      <h2><i class="fa-regular fa-cubes"></i> 核心功能模块</h2>
      <div class="card-grid-4">
        <!-- 模块1：政府权威数据智能采集 -->
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-spider"></i></div>
          <h3>政府权威数据智能采集</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 工商/四库一平台/第三方</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 企业股东/董高监/资质</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 100+字段结构化采集</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 自动清洗、持续更新</li>
          </ul>
          <div style="margin-top: 16px;"><span class="keyword-tag">爬虫采集</span> <span class="keyword-tag">工商数据</span></div>
        </div>
        <!-- 模块2：内部系统数据融合 -->
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-database"></i></div>
          <h3>内部系统数据融合</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> ERP/NC/人资/ECP系统</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 员工花名册/亲属信息</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 投标IP/MAC地址</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 供应商交易往来数据</li>
          </ul>
          <div style="margin-top: 16px;"><span class="keyword-tag">数据中台</span> <span class="keyword-tag">内外部融合</span></div>
        </div>
        <!-- 模块3：十大数据中间表建模 -->
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-table"></i></div>
          <h3>十大数据中间表建模</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 工商基础/股东/主要人员</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 疑似关系/法人关联/邮箱关联</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 资质/注册人员/标签</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 员工及家属关联企业表</li>
          </ul>
          <div style="margin-top: 16px;"><span class="keyword-tag">关系图谱</span> <span class="keyword-tag">关联分析</span></div>
        </div>
        <!-- 模块4：重点审计场景智能分析 -->
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-magnifying-glass"></i></div>
          <h3>重点审计场景智能分析</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 员工违规经商办企业</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 围标串标/不良供应商</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 员工挂证/三指定排查</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 工程肢解转包分析</li>
          </ul>
          <div style="margin-top: 16px;"><span class="keyword-tag">违规经商</span> <span class="keyword-tag">围标串标</span></div>
        </div>
      </div>
      <div style="text-align: center; margin-top: 20px;">
        <p><strong>+ 可视化分析与前端操作平台：</strong> 图谱分析、傻瓜式操作、一键生成疑点清单、数据导出。</p>
      </div>
    </section>

    <!-- 十大中间表列表展示 -->
    <section class="gov-container">
      <h2><i class="fa-regular fa-layer-group"></i> 十大数据中间表 · 支撑多维度关联分析</h2>
      <div class="arch-card">
        <div style="display: flex; flex-wrap: wrap; gap: 10px; justify-content: center; margin-bottom: 20px;">
          <span class="compliance-badge">工商基础信息</span>
          <span class="compliance-badge">企业股东信息</span>
          <span class="compliance-badge">主要人员及关联企业</span>
          <span class="compliance-badge">企业疑似关系</span>
          <span class="compliance-badge">法人关联企业</span>
          <span class="compliance-badge">邮箱关联企业</span>
          <span class="compliance-badge">企业资质信息</span>
          <span class="compliance-badge">企业注册人员</span>
          <span class="compliance-badge">企业性质标签</span>
          <span class="compliance-badge">员工及家属关联企业</span>
        </div>
        <p style="text-align: center;">通过十大中间表，构建完整的企业关系网络，支持穿透式审计分析。</p>
      </div>
    </section>

    <!-- 重点审计场景详细展示 -->
    <section class="gov-container">
      <h2><i class="fa-regular fa-bolt"></i> 重点审计场景智能分析</h2>
      <div class="scene-grid">
        <div class="scene-item">
          <h3><i class="fa-regular fa-user-tie" style="color: var(--gov-accent-blue);"></i> 员工违规经商办企业</h3>
          <p>员工与企业股东交叉比对，亲属关联企业排查，外部企业投资行为识别，自动生成疑点清单。</p>
        </div>
        <div class="scene-item">
          <h3><i class="fa-regular fa-handshake" style="color: var(--gov-accent-blue);"></i> 围标串标与不良供应商</h3>
          <p>投标单位IP/MAC地址比对，企业关联关系分析，供应商异常交易行为识别，锁定围标嫌疑。</p>
        </div>
        <div class="scene-item">
          <h3><i class="fa-regular fa-id-card" style="color: var(--gov-accent-blue);"></i> 员工挂证/三指定问题</h3>
          <p>企业资质与员工岗位比对，注册人员信息交叉验证，排查违规挂证与指定关系。</p>
        </div>
        <div class="scene-item">
          <h3><i class="fa-regular fa-code-branch" style="color: var(--gov-accent-blue);"></i> 工程肢解转包分析</h3>
          <p>合同拆分识别，项目异常交易分析，发现转包分包风险。</p>
        </div>
      </div>
    </section>

    <!-- 项目成果与价值（数据指标） -->
    <section class="gov-container">
      <h2><i class="fa-regular fa-chart-simple"></i> 项目成果与价值</h2>
      <div class="stat-grid">
        <div class="stat-card">
          <div class="stat-number">50%+</div>
          <p>审计线索获取效率提升</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">显著降低</div>
          <p>外部数据采购成本</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">实时</div>
          <p>数据持续更新</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">全覆盖</div>
          <p>审计监督常态化</p>
        </div>
      </div>
      <div style="margin-top: 40px;">
        <ul style="list-style: none; display: flex; flex-wrap: wrap; gap: 30px; justify-content: center;">
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 自动采集+比对，疑点发现效率提升50%以上</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 减少人工采集与外部数据采购费用</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 通过数据充分性保障审计结论支撑力度</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 支撑"科技强审""审计全覆盖"战略落地</li>
        </ul>
      </div>
    </section>

    <!-- 适用客户类型 -->
    <section class="gov-container">
      <h2><i class="fa-regular fa-users"></i> 适用客户群体</h2>
      <div class="client-tags">
        <span class="client-tag">央企集团</span>
        <span class="client-tag">地方国企</span>
        <span class="client-tag">建筑施工企业</span>
        <span class="client-tag">能源企业</span>
        <span class="client-tag">金融机构</span>
        <span class="client-tag">政府监管部门</span>
        <span class="client-tag">审计机关</span>
      </div>
    </section>

    <!-- 客户成功案例 -->
    <section class="gov-container">
      <h2><i class="fa-regular fa-briefcase"></i> 客户成功案例</h2>
      <div class="card-grid-3">
        <div class="case-card">
          <i class="fa-solid fa-building-columns" style="font-size: 2rem; color: var(--gov-primary-dark);"></i>
          <div class="case-stats">-35%</div>
          <p><strong>某电力央企</strong> — 通过平台发现12起员工违规经商，挽回经济损失超800万元。</p>
        </div>
        <div class="case-card">
          <i class="fa-solid fa-phone" style="font-size: 2rem; color: var(--gov-primary-dark);"></i>
          <div class="case-stats">+60%</div>
          <p><strong>省级建工集团</strong> — 围标串标识别率提升60%，供应商风险预警提前3个月。</p>
        </div>
        <div class="case-card">
          <i class="fa-solid fa-truck" style="font-size: 2rem; color: var(--gov-primary-dark);"></i>
          <div class="case-stats">100%</div>
          <p><strong>大型制造企业</strong> — 实现供应商全生命周期关联关系监控，挂证问题清零。</p>
        </div>
      </div>
    </section>

    <!-- 常见问题 FAQ -->
    <section class="gov-container">
      <h2 style="text-align: center;"><i class="fa-regular fa-circle-question"></i> 常见问题</h2>
      <div class="faq-list">
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 爬虫采集是否合规？数据来源是否权威？</div>
          <div class="faq-answer">平台仅采集政府公开公示数据（国家企业信用信息公示系统、四库一平台等），符合法律法规，数据权威可靠。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 如何保证数据实时性？</div>
          <div class="faq-answer">支持定时自动增量采集，可根据需求设置更新频率（天/周/月），确保数据最新。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 能否与现有审计系统集成？</div>
          <div class="faq-answer">提供标准化API接口，可无缝对接古杉非现场审计平台及其他审计系统，实现疑点数据自动推送。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 实施需要多久？</div>
          <div class="faq-answer">一般1-2个月完成试点部署，包括爬虫配置、内部数据对接、模型调试和人员培训。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 是否支持个性化场景定制？</div>
          <div class="faq-answer">支持根据企业业务特点扩展审计场景，如特定行业资质、特殊关联关系等。</div>
        </div>
      </div>
    </section>

    <!-- 最终CTA -->
    <section class="gov-container" style="padding-bottom: 80px;">
      <div class="cta-block">
        <h2 style="font-size: 2.4rem;">构建外部数据驱动的智能审计平台</h2>
        <p style="font-size: 1.2rem; margin: 16px 0 40px; opacity: 0.9;">预约专家演示，了解如何通过爬虫采集政府公示数据，融合内部系统，实现审计线索智能挖掘。</p>
        <div style="display: flex; gap: 20px; justify-content: center; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal" style="background: white; color: var(--gov-primary-dark);">预约免费演示</a>
          <a href="tel:4008881234" class="btn btn-outline" style="border-color: white; color: white;">致电 400-888-1234</a>
        </div>
        <p style="margin-top: 32px; font-size: 1rem;"><i class="fa-regular fa-envelope"></i> 发送需求至 spider@gushandata.cn</p>
      </div>
    </section>

    <!-- 预约演示模态框 -->
    <div class="modal" :style="{ display: showModal ? 'flex' : 'none' }">
      <div class="modal-content">
        <span class="close-modal" @click="closeModal">&times;</span>
        <h3><i class="fa-regular fa-calendar-check" style="color: var(--gov-primary-dark);"></i> 预约专家演示</h3>
        <form @submit.prevent="submitDemo">
          <div class="form-group">
            <input type="text" v-model="form.name" placeholder="姓名 *" required>
          </div>
          <div class="form-group">
            <input type="text" v-model="form.company" placeholder="公司名称">
          </div>
          <div class="form-group">
            <input type="email" v-model="form.email" placeholder="工作邮箱 *" required>
          </div>
          <div class="form-group">
            <input type="tel" v-model="form.phone" placeholder="联系电话">
          </div>
          <div class="form-group">
            <textarea rows="3" v-model="form.message" placeholder="您的需求或问题（选填）"></textarea>
          </div>
          <button type="submit" class="btn btn-primary">提交预约</button>
        </form>
      </div>
    </div>

    <!-- footer -->
    <footer class="gov-container">
      <p>© 2026 古杉数据 · 政府公示数据采集审计平台 | 爬虫审计 · 外部数据融合 · 智能线索挖掘</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'GovernmentInfoCollectionDetail',
  data() {
    return {
      showModal: false,
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    submitDemo() {
      alert('感谢您的预约，古杉数据专家将在24小时内与您联系。');
      this.showModal = false;
      this.form = { name: '', company: '', email: '', phone: '', message: '' };
    },
    downloadBrochure() {
      alert('产品手册下载中…… (实际可替换为PDF链接)');
    }
  }
};
</script>

<style scoped>
.gov-info-page {
  --gov-primary-dark: #1D4E4E;
  --gov-primary-soft: #e9f3f2;
  --gov-accent-gold: #D4AF37;
  --gov-accent-blue: #2A7DE1;
  --gov-gray-light: #f8fafc;
  --gov-gray-border: #e2e8f0;
  --gov-text-dark: #0f2a2a;
  --gov-text-regular: #2d3f4b;
  --gov-white: #ffffff;
  --gov-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);

  background-color: #ffffff;
  color: var(--gov-text-regular);
  line-height: 1.5;
  font-family: 'Inter', 'PingFang SC', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 面包屑导航 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}

.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-nav .current {
  color: var(--gov-accent-blue);
  font-weight: 600;
}

.gov-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

section.gov-container {
  padding: 64px 24px;
}

h1, h2, h3 {
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--gov-text-dark);
}

h1 {
  font-size: 3.2rem;
  line-height: 1.2;
}

h2 {
  font-size: 2.2rem;
  margin-bottom: 24px;
}

h2 i {
  color: var(--gov-accent-blue);
  margin-right: 8px;
}

h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.subhead {
  font-size: 1.2rem;
  color: #4f6f7f;
  max-width: 800px;
  margin-bottom: 40px;
}

.btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 40px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1rem;
  border: 1px solid transparent;
  cursor: pointer;
}

.btn-primary {
  background-color: var(--gov-primary-dark);
  color: white;
  box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
}

.btn-primary:hover {
  background-color: #0e3a3a;
  transform: translateY(-2px);
}

.btn-outline {
  background-color: transparent;
  border: 1.5px solid var(--gov-primary-dark);
  color: var(--gov-primary-dark);
}

.btn-outline:hover {
  background-color: var(--gov-primary-dark);
  color: white;
}

.btn-accent {
  background-color: var(--gov-accent-blue);
  color: white;
  box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
}

.btn-accent:hover {
  background-color: #1b64c5;
  transform: translateY(-2px);
}

/* 关键词标签云 */
.keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.keyword-tag {
  background: var(--gov-primary-soft);
  color: var(--gov-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.keyword-tag.highlight {
  background: var(--gov-accent-gold);
  color: #1e3c3c;
}

/* 卡片网格 */
.card-grid-3, .card-grid-4 {
  display: grid;
  gap: 24px;
  margin: 40px 0;
}

.card-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.card-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.feature-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--gov-shadow);
  border: 1px solid var(--gov-gray-border);
  transition: transform 0.2s;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.card-icon {
  font-size: 2.5rem;
  color: var(--gov-primary-dark);
  margin-bottom: 20px;
}

.list-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-start;
}

.list-item i {
  color: var(--gov-accent-blue);
  font-size: 1.1rem;
  margin-top: 3px;
  min-width: 20px;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.stat-card {
  background: var(--gov-primary-soft);
  border-radius: 32px;
  padding: 32px 24px;
  text-align: center;
}

.stat-number {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--gov-primary-dark);
  margin-bottom: 8px;
}

.client-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.client-tag {
  background: white;
  border: 1px solid var(--gov-gray-border);
  padding: 8px 22px;
  border-radius: 40px;
  font-weight: 500;
  color: var(--gov-text-dark);
}

.case-card {
  background: white;
  border-radius: 24px;
  padding: 28px;
  box-shadow: var(--gov-shadow);
}

.case-stats {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--gov-primary-dark);
  margin: 16px 0 8px;
}

/* 技术架构卡片 */
.arch-card {
  background: var(--gov-primary-soft);
  border-radius: 32px;
  padding: 36px;
  margin-top: 30px;
}

.arch-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.arch-item {
  background: white;
  border-radius: 24px;
  padding: 24px;
}

/* 合规认证 */
.compliance-badge {
  display: inline-block;
  background: var(--gov-accent-gold);
  color: #1e3c3c;
  padding: 8px 18px;
  border-radius: 40px;
  font-weight: 600;
  margin-right: 12px;
  margin-bottom: 12px;
}

/* 场景卡片 */
.scene-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 30px;
}

.scene-item {
  background: white;
  border-radius: 20px;
  padding: 20px;
  border-left: 5px solid var(--gov-accent-blue);
  box-shadow: var(--gov-shadow);
}

/* FAQ */
.faq-list {
  max-width: 900px;
  margin: 40px auto 0;
}

.faq-item {
  padding: 22px 0;
  border-bottom: 1px solid var(--gov-gray-border);
}

.faq-question {
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  gap: 16px;
  color: var(--gov-text-dark);
}

.faq-question i {
  color: var(--gov-accent-gold);
}

.faq-answer {
  margin-top: 12px;
  color: #3f5465;
  padding-left: 40px;
}

.cta-block {
  background: var(--gov-primary-dark);
  border-radius: 56px;
  padding: 64px 56px;
  color: white;
  text-align: center;
}

.cta-block h2 {
  color: white;
}

.cta-block .btn-primary {
  background-color: white;
  color: var(--gov-primary-dark);
  margin: 0 8px;
}

.cta-block .btn-outline {
  border-color: white;
  color: white;
}

.cta-block .btn-outline:hover {
  background-color: white;
  color: var(--gov-primary-dark);
}

/* 模态框 */
.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  border-radius: 40px;
  max-width: 500px;
  width: 90%;
  padding: 40px;
  box-shadow: 0 30px 60px rgba(0,0,0,0.3);
  position: relative;
}

.close-modal {
  position: absolute;
  top: 20px;
  right: 24px;
  font-size: 28px;
  cursor: pointer;
  color: #999;
}

.modal h3 {
  margin-bottom: 24px;
}

.modal .form-group {
  margin-bottom: 20px;
}

.modal input, .modal textarea {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid var(--gov-gray-border);
  border-radius: 30px;
  font-size: 1rem;
  outline: none;
}

.modal textarea {
  border-radius: 20px;
}

.modal .btn {
  width: 100%;
  margin-top: 10px;
}

footer {
  text-align: center;
  padding: 40px 0;
  color: #7f8d9c;
  border-top: 1px solid var(--gov-gray-border);
  margin-top: 40px;
}

/* 响应式 */
@media (max-width: 1000px) {
  .card-grid-3, .card-grid-4, .stat-grid, .arch-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .scene-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .card-grid-3, .card-grid-4, .stat-grid, .arch-grid {
    grid-template-columns: 1fr;
  }
  .scene-grid {
    grid-template-columns: 1fr;
  }
  .gov-info-page h1 { font-size: 2.5rem; }
}
</style>
